import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { FaEye } from 'react-icons/fa'; // Import the eye icon
import './AllOrderList.css'; // Import the CSS file for styling

const ExpiryMedicineList = () => {
  const [userData, setUserData] = useState([]);
  const history = useHistory();

  useEffect(() => {
    // Set static data
    setUserData([
      {
        id: 1,
        productName: 'Medicine A',
        vendorName: 'Vendor A',
        userName: 'John Doe',
        totalAmount: 'Rs.100',
        status: 'Pending'
      },
      {
        id: 2,
        productName: 'Medicine B',
        vendorName: 'Vendor B',
        userName: 'Jane Smith',
        totalAmount: 'Rs.200',
        status: 'Shipped'
      },
      {
        id: 3,
        productName: 'Medicine C',
        vendorName: 'Vendor C',
        userName: 'Alice Johnson',
        totalAmount: 'Rs.300',
        status: 'Delivered'
      },
      // Add more static data as needed
    ]);
  }, []);

  const handleViewMore = (id) => {
    console.log('View more details for order ID:', id);
    // You can navigate to another page with the history.push or show a modal with more details
  };

  // Function to get the status color
  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending':
        return 'blue';
      case 'Shipped':
        return 'green';
      case 'Delivered':
        return 'red';
      default:
        return 'black';
    }
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Expiry Medicine List</h2>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Product Name</th>
                <th>Vendor Name</th>
                <th>User Name</th>
                <th>Total Amount</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {userData.map((order, index) => (
                <tr key={order.id}>
                  <td>{index + 1}</td>
                  <td>{order.productName}</td>
                  <td>{order.vendorName}</td>
                  <td>{order.userName}</td>
                  <td>{order.totalAmount}</td>
                  <td style={{ color: getStatusColor(order.status) }}>
                    {order.status}
                  </td>
                  <td>
                    <button
                      onClick={() => handleViewMore(order.id)}
                      style={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        color: 'blue',
                        cursor: 'pointer'
                      }}
                    >
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(ExpiryMedicineList);
